import { supabase } from '../lib/supabase';

interface CreateChannelResult {
  success: boolean;
  channel_id?: string;
  channel_name?: string;
  error?: string;
}

interface DeleteChannelResult {
  success: boolean;
  error?: string;
}

interface MoveResult {
  success: boolean;
  moved: string[];
  errors: string[];
}

/**
 * Create a temporary voice channel in a Discord guild.
 */
export async function createVoiceChannel(
  guildId: string,
  channelName: string,
  categoryId?: string
): Promise<CreateChannelResult> {
  try {
    const { data, error } = await supabase.functions.invoke('discord-vc', {
      body: { action: 'create', guild_id: guildId, channel_name: channelName, category_id: categoryId },
    });

    if (error) {
      console.error('Discord create channel error:', error);
      return { success: false, error: error.message };
    }

    return data as CreateChannelResult;
  } catch (err: any) {
    console.error('Failed to create voice channel:', err);
    return { success: false, error: err.message || 'Unknown error' };
  }
}

/**
 * Delete a voice channel from a Discord guild.
 */
export async function deleteVoiceChannel(
  guildId: string,
  channelId: string
): Promise<DeleteChannelResult> {
  try {
    const { data, error } = await supabase.functions.invoke('discord-vc', {
      body: { action: 'delete', guild_id: guildId, channel_id: channelId },
    });

    if (error) {
      console.error('Discord delete channel error:', error);
      return { success: false, error: error.message };
    }

    return data as DeleteChannelResult;
  } catch (err: any) {
    console.error('Failed to delete voice channel:', err);
    return { success: false, error: err.message || 'Unknown error' };
  }
}

/**
 * Move Discord users into a voice channel (fallback approach).
 */
export async function moveUsersToVoiceChannel(
  guildId: string,
  channelId: string,
  userIds: string[]
): Promise<MoveResult> {
  try {
    const { data, error } = await supabase.functions.invoke('discord-vc', {
      body: { action: 'move', guild_id: guildId, channel_id: channelId, user_ids: userIds },
    });

    if (error) {
      console.error('Discord move users error:', error);
      return { success: false, moved: [], errors: [error.message] };
    }

    return data as MoveResult;
  } catch (err: any) {
    console.error('Failed to move users to voice channel:', err);
    return { success: false, moved: [], errors: [err.message || 'Unknown error'] };
  }
}
